import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { get, size } from 'lodash'
import { Container, Typography } from '@material-ui/core'
import moment from 'moment'

import resultsStyles from './css/resultsStyles'
import RangeDateSection from '../../sections/RangeDateSection/RangeDateSection'
import CustomTable from '../../components/table/CustomTable'
import { fetchData } from '../../api/api'
import ButtonBackHeader from '../../components/ButtonBackHeader/ButtonBackHeader'
import { dateToString } from '../../assets/helperFunctions'

const headCellsOcTicket = [
  { id: 'id', numeric: false, order: false, label: 'OC/Ticket' },
  { id: 'numeroTrx', numeric: false, order: false, label: 'Transacción' },
  { id: 'fecha', numeric: false, order: false, label: 'Fecha' },
  { id: 'formaPago', numeric: false, order: false, label: 'Medio pago' },
  { id: 'sucursal', numeric: false, order: false, label: 'Sucursal' },
  { id: 'caja', numeric: false, order: false, label: 'Caja' },
  { id: 'notaCredito', numeric: false, order: false, label: 'Nota crédito' },
  { id: 'sucursalCom', numeric: false, order: false, hide: true, label: 'sucursalCom' },
  { id: 'boleta', numeric: false, order: false, hide: true, label: 'boleta' },
]

const createOcTicketRows = ({
  id = '-',
  numeroTrx = '-',
  fecha = '-',
  formaPago = '-',
  sucursal = '-',
  caja = '-',
  notaCredito = '-',
  sucursalCom = '-',
  boleta = '-',
}) => {
  return { id, numeroTrx, fecha, formaPago, sucursal, caja, notaCredito, sucursalCom, boleta }
}

const Results = ({ location }) => {
  const classes = resultsStyles()
  const history = useHistory()

  const state = JSON.parse(get(location, 'state') || {})
  const fetchObject = get(state, 'fetchObject') || {}
  const orderData = get(state, 'orderData') || {}

  const [initialDate, setInitialDate] = React.useState(
    moment(get(fetchObject, 'dateStart') || '', 'DD-MM-YYYY') || moment()
  )
  const [finalDate, setFinalDate] = React.useState(
    moment(get(fetchObject, 'dateEnd') || '', 'DD-MM-YYYY') || moment()
  )

  const [tableRows, setTableRows] = useState(
    (get(orderData, 'data.data') || []).map(row =>
      createOcTicketRows({
        id: get(row, 'ordenCompra'),
        numeroTrx: get(row, 'numeroTrx'),
        fecha: get(row, 'fecha'),
        formaPago: get(row, 'formaPago'),
        sucursal: get(row, 'sucursal'),
        caja: get(row, 'caja'),
        notaCredito: get(row, 'notaCredito'),
        sucursalCom: get(row, 'sucursalCom'),
        boleta: get(row, 'boleta'),
      })
    )
  )
  const [curretPage, setCurrentPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState('id')
  const [numberOfPages, setNumberOfPages] = useState(1)
  const [isDataLoading, setIsDataLoading] = useState(false)

  const handleRowClick = (row = {}) => {
    return history.push({
      pathname: 'detalle',
      state: {
        row: { ...row },
        fetchObject: { ...fetchObject },
      },
    })
  }

  useEffect(() => {
    const fetchFormData = async () => {
      setIsDataLoading(true)
      try {
        const tableDataApi = await fetchData({
          ...fetchObject,
          dateStart: dateToString(initialDate),
          dateEnd: dateToString(finalDate),
          size: rowsPerPage,
          page: curretPage,
        })

        setNumberOfPages(get(tableDataApi, 'pages.total') || 1)
        setTableRows(
          (get(tableDataApi, 'data.data') || []).map(row =>
            createOcTicketRows({
              id: get(row, 'ordenCompra'),
              numeroTrx: get(row, 'numeroTrx'),
              fecha: get(row, 'fecha'),
              formaPago: get(row, 'formaPago'),
              sucursal: get(row, 'sucursal'),
              caja: get(row, 'caja'),
              notaCredito: get(row, 'notaCredito'),
              sucursalCom: get(row, 'sucursalCom'),
              boleta: get(row, 'boleta'),
            })
          )
        )

        return setIsDataLoading(false)
      } catch (error) {
        setIsDataLoading(false)
        return error
      }
    }
    if (
      initialDate.format('DD-MM-YYYY') !== get(fetchObject, 'dateStart') ||
      finalDate.format('DD-MM-YYYY') !== get(fetchObject, 'dateEnd') ||
      rowsPerPage !== get(orderData, 'data.page.pageSize') ||
      curretPage + 1 !== get(orderData, 'data.page.currentPage')
    )
      fetchFormData()
  }, [initialDate, finalDate, rowsPerPage, curretPage])

  const handleActionButtonClick = () => {
    return history.push('buscar')
  }

  return (
    <div className={classes.root}>
      <Container className={classes.container}>
        <ButtonBackHeader
          buttonText="Nueva búsqueda"
          onActionButtonClick={handleActionButtonClick}
          icon="search"
        />
        <Typography variant="h5">Resultados</Typography>
        <Typography variant="body1" gutterBottom color="textSecondary">
          {size(tableRows)} comprobantes encontrados
        </Typography>
        <RangeDateSection
          initialDate={initialDate}
          finalDate={finalDate}
          setInitialDate={setInitialDate}
          setFinalDate={setFinalDate}
        />
        <CustomTable
          className={classes.table}
          rows={tableRows}
          headCells={headCellsOcTicket}
          actionTable
          eraseButton
          page={curretPage}
          setPage={setCurrentPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          order={order}
          setOrder={setOrder}
          orderBy={orderBy}
          setOrderBy={setOrderBy}
          isDataLoading={isDataLoading}
          onRowClick={handleRowClick}
          numberOfPages={numberOfPages}
        />
      </Container>
    </div>
  )
}

Results.propTypes = {}

export default Results
